import React, { useState, useEffect } from "react";
import { Tabs, Row, Col, Button, Spin } from "antd";
import { isMobile } from "@/utils/public";
import axios from "axios";
import API from "@/api";
import ZntsjSq from "./zntsjsq";
import Zntsjsh from "./zntsjsh";

function ZntSj() {
  const [tab, setTab] = useState("sq");
  const isMob = isMobile();
  const [spinning, setSpinning] = useState(true);
  const [userInfo, setUserInfo] = useState({});
  const [zntTypes, setZntTypes] = useState([]);
  const [orgs, setOrgs] = useState([]);
  const [departments, setDepartments] = useState([]);
  const tabs = [
    {
      label: "智能体上架申请",
      key: "sq",
      children:
        tab === "sq" ? (
          <ZntsjSq
            types={zntTypes}
            orgs={orgs}
            departments={departments}
            userInfo={userInfo}
          />
        ) : undefined,
    },
  ];

  useEffect(() => {
    axios.all([getUserInfo(), getZntTypes(), getZntDepartment()]).then(
      axios.spread((res, res1, res2) => {
        const data = res?.data?.result?.data || {};
        const data1 = res1?.data?.result?.data || {};
        const data2 = res2?.data?.result?.data || {};
        const arr = [];
        const arr1 = [];
        setUserInfo(data);
        data1.map((item) => {
          arr.push({
            label: item.name,
            value: item.code,
          });
        });
        data2.map((item) => {
          arr1.push({
            label: item.name,
            value: item.code,
            id:item.id
          });
        });
        setOrgs(data?.orgs);
        setZntTypes(arr);
        setDepartments(arr1);
        setSpinning(false);
      })
    );
  }, []);

  const getUserInfo = () => {
    return axios.get(API.getUserInfo);
  };

  const getZntTypes = () => {
    return axios.get(API.getZntTypes);
  };

  const getZntDepartment = () => {
    return axios.get(API.getZntDepartment);
  };

  if (userInfo?.modelAudit) {
    tabs.push({
      label: "智能体上架审核",
      key: "sh",
      children:
        tab === "sh" ? (
          <Zntsjsh
            types={zntTypes}
            orgs={orgs}
            departments={departments}
            userInfo={userInfo}
          />
        ) : undefined,
    });
  }

  return (
    <div className={`${isMob ? "m-zdSearchContent" : "zdSearchContent"}`}>
      <div className="content">
        <Spin spinning={false}>
          <Tabs
            activeKey={tab}
            onChange={(activeKey) => {
              setTab(activeKey);
            }}
            style={{
              height: "100%",
            }}
            type="card"
            items={tabs}
            tabBarGutter={15}
          />
        </Spin>
      </div>
    </div>
  );
}

export default ZntSj;
